export const WORKSPACE_ROLES = ["owner", "editor", "approver"];
/**
 * How long an account sits between "delete me" and actually being deleted.
 *
 * Here rather than in the api because three places need the same number: the
 * worker schedules the purge by it, the dashboard counts down to it, and the
 * public /data-deletion page states it as a promise. Two copies of a promise
 * is one copy too many.
 */
export const DELETION_GRACE_DAYS = 30;
export const PLATFORMS = ["facebook", "instagram", "threads", "linkedin", "x"];
/** X/Twitter is pay-per-post, deferred past MVP — shown as "Coming soon". */
export const CONNECTABLE_PLATFORMS = [
    "facebook",
    "instagram",
    "threads",
    "linkedin",
];
/**
 * `unlimited` is an internal tier, not a sellable one.
 *
 * It exists for our own accounts, for a client being comped, and for testing
 * a flow that a real plan's ceiling would block. It is deliberately last so
 * nothing that iterates these for a pricing page picks it up first, and it is
 * never offered at checkout — a workspace is moved onto it by hand.
 */
export const PLAN_KEYS = ["free", "solo", "pro", "agency", "unlimited"];
/** Plans that can actually be bought. Use this for anything customer-facing. */
export const SELLABLE_PLAN_KEYS = ["free", "solo", "pro", "agency"];
/**
 * Tiers granted by hand rather than bought.
 *
 * Named once, because three separate places have to agree about it: the
 * Paystack webhook (which must not revoke a grant it never made), the billing
 * page (which must not offer to sell a downgrade), and the script that does
 * the granting. A string literal in each is three chances to add a second
 * internal tier and miss one.
 */
export const INTERNAL_PLAN_KEYS = ["unlimited"];
export function isInternalPlan(plan) {
    return INTERNAL_PLAN_KEYS.includes(plan ?? "");
}
export const POST_STATUSES = [
    "draft",
    "pending_approval",
    "approved",
    "scheduled",
    "published",
    "partially_failed",
    "failed",
    "skipped",
];
export const POST_ORIGINS = [
    "calendar",
    "photo",
    "cart10_event",
    "campaign",
    "monthly_plan",
    "manual",
];
//# sourceMappingURL=types.js.map